/**
 * lib/storefront/wick_guide/wax-group.js
 */

class WaxGroup {
  constructor(groupName, waxesInGroup) {
    this.name = groupName;
    this.waxes = waxesInGroup;
  }
}

export default WaxGroup;
